import { apiMipe } from '@/core/api/';
const BASE_URL = 'api/student';

export const getBySie = (sieId, webServiceSearchOnly = false) => {
  let uri = `${BASE_URL}/getstudent?studentSie=${sieId}`;

  if (webServiceSearchOnly) uri += `&searchMode=2`;

  return apiMipe.get(uri);
};

export const getStudentDetailsBySie = (studentSie, syncFlag) => {
  return apiMipe.get(
    `${BASE_URL}/getstudentdetails?studentSie=${studentSie}&syncFlag=${syncFlag}`
  );
};

export const getStudentDetailsWithEnrollmentSchool = (studentSie) => {
  return apiMipe.get(`${BASE_URL}/getstudentdetailswithenrollmentSchool`, {
    params: {
      studentSie,
    },
  });
};

export const getStudentEnrollmentDetail = (studentSie) => {
  return apiMipe.get(`${BASE_URL}/studentenrollmentdetails`, {
    params: {
      studentSie,
    },
  });
};

export const getPeiHistory = (studentSieId, year, pageNumber, pageSize) => {
  return apiMipe.get('/api/pei/gethistory', {
    params: {
      studentSieId,
      year,
      pageNumber,
      pageSize,
    },
  });
};

export const getAcademicYears = () => apiMipe.get('/api/academicyears/');

export const getAdvancedSearch = (parameters) => {
  return apiMipe.get(`${BASE_URL}/advancedstudentsearch`, {
    params: {
      ...parameters,
    },
  });
};

export const saveHistorySearch = (studentSieId) => {
  return apiMipe.post(`${BASE_URL}/savehistorysearch`, {
    params: {
      studentSieId,
    },
  });
};

export const getImpediments = () => {
  return apiMipe.get('api/code/getprimaryimpediments');
};

export const getContactInformation = async (studentSieId) => {
  return await apiMipe.get(`/api/student/${studentSieId}/ContactInformation`);
};

export const getStudentInformation = (sieId) => {
  let uri = `${BASE_URL}/information?studentSie=${sieId}`;

  return apiMipe.get(uri);
};

export const getStudentStatuses = (statusId) =>
  apiMipe.get(`${BASE_URL}/getstatuses`, {
    params: {
      statusId,
    },
  });

export const getAppointmentAdditionalInfo = (clientAppointmentId) =>
  apiMipe.get(
    `api/appointment/appointmentadditionalinfo/${clientAppointmentId}`
  );

export const getAppointmentTherapies = (clientAppointmentId) =>
  apiMipe.get(`api/appointment/appointmenttherapies/${clientAppointmentId}`);
